import { render, staticRenderFns } from "./Museu.vue?vue&type=template&id=2f084932&scoped=true&"
import script from "./Museu.vue?vue&type=script&lang=js&"
export * from "./Museu.vue?vue&type=script&lang=js&"
import style0 from "./Museu.vue?vue&type=style&index=0&id=2f084932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f084932",
  null
  
)

export default component.exports